export { default as Form } from 'depreciations/components/form/DepreciationForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/form/index.js